import styled from 'styled-components';

export const DropdownMenu = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  z-index: 1;
  background: #fff;
  width: 100%;
  text-align: center;

  .notice {
    background: #e5e9f2;
    border: 1px solid #d2daef;
    padding: 0 10px;
    box-sizing: border-box;
    border-radius: 4px;
    height: 30px;
    margin: 20px 10px 0;
    display: flex;
    align-items: center;
  }

  .loader {
    display: ${props =>
      props.componentsState === 'loading' ? 'block' : 'none'};
    height: 4px;
    width: 100%;
    padding: 0;
    position: relative;
    overflow: hidden;
    background-color: #ebeef0;
  }

  .loader:before {
    display: block;
    position: absolute;
    content: '';
    left: -200px;
    width: 200px;
    height: 4px;
    background-color: rgb(4, 21, 56);
    animation: loading 2s linear infinite;
  }

  @keyframes loading {
    from {
      left: -200px;
      width: 30%;
    }
    50% {
      width: 30%;
    }
    70% {
      width: 70%;
    }
    80% {
      left: 50%;
    }
    95% {
      left: 120%;
    }
    to {
      left: 100%;
    }
  }

  > div {
    text-align: left;
    font-size: 14px;
    color: #52708d;
  }
`;

export const FooterDrawer = styled.div`
  display: flex;
  padding: 12px 16px 12px 16px;
  border-top: 1px solid #dadfe3;
  background: #ebeff3;
`;

export const ControlButton = styled.div`
  height: 100%;
  line-height: 27px;
  font-size: 14px;
  font-weight: 600;
  color: #52708d;
`;

export const MenuButton = styled.div`
  padding: 0 10px 4px 3px;
  position: relative;
  display: flex;
  align-items: center;
  color: #525252;
  font-size: 14px;
  user-select: none;
  padding: 0;
  height: 30px;

  > div {
    margin-left: 4px;
  }
  &:hover {
    color: #525252;
  }
`;

export const Title = styled.div`
  border-radius: 3px;
  border-top: ${props =>
    props.componentsState === 'loading' ? '0' : '4px solid #acaaff'};
  font-size: 18px;
  font-weight: 600;
  color: #12344d;
  padding: 15px 20px;
  border-bottom: 1px dotted #cfcfcf;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex: none;
  align-self: center;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  white-space: nowrap;
  word-break: keep-all;
  cursor: pointer;
  /* border: 1px solid #dadada; */
  border-radius: 3px;
  background: #f5f5f9;
  font-size: ${props => (props.large ? '18px' : '14px')};
  line-height: 1;
  position: relative;
  text-align: center;
  margin: -40px 10px 10px 9px;
  border-top: 1px solid #d8d6d6;
  border-radius: 1px;

  &:hover {
    background: #ededf4;
  }
`;
